const clone = (obj, copyNested = true) => {
  let result = {};
  for (let prop in obj) {
    if (obj.hasOwnProperty(prop)) {
      if (Array.isArray(obj[prop])) {
        result[prop] = [];
        obj[prop].forEach(el => {
          result[prop].push(el);
        });
      } else if (copyNested && typeof obj[prop] == "object") {
        result[prop] = clone(obj[prop], copyNested);
      } else {
        result[prop] = obj[prop];
      }
    }
  }
  return result;
};

const guid = () => {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return (
    s4() +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    "-" +
    s4() +
    s4() +
    s4()
  );
};

export { clone, guid };
